import * as React from "react";
import { Container } from "../../icons";
import { withVariationColors } from "../../colorVariations";
const SvgComponent = (
  { primaryColor, secondaryColor, title, titleId, fillColor, ...props },
  svgRef
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 54 54"
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="none" fillRule="evenodd">
      <path
        fill={primaryColor}
        fillRule="nonzero"
        d="M18.14 53.16a.42.42 0 110 .84.42.42 0 010-.84zm16.03-5.06a.42.42 0 110 .84.42.42 0 010-.84zM4.01 45.57a.63.63 0 110 1.26.63.63 0 010-1.26zm38.18-.85a.84.84 0 110 1.68.84.84 0 010-1.68zm5.48-10.13a2.11 2.11 0 110 4.22 2.11 2.11 0 010-4.22zm0 .85a1.27 1.27 0 101.27 1.26 1.26 1.26 0 00-1.27-1.26zm0-8.44a.21.21 0 01.19.11l.26.49a.56.56 0 00.22.21l.49.27a.21.21 0 010 .37l-.49.27a.56.56 0 00-.22.21l-.26.49a.21.21 0 01-.37 0c-.04-.06-.22-.4-.27-.49a.53.53 0 00-.21-.21l-.5-.27a.22.22 0 010-.37l.5-.27a.53.53 0 00.21-.21c.05-.09.27-.43.27-.49a.21.21 0 01.18-.11zM.63 20.25a.63.63 0 110 1.26.63.63 0 010-1.26zM5.91 9.28a.28.28 0 01.24.15c.05.08.29.53.36.65s.17.22.29.29l.65.35a.29.29 0 01.14.28.27.27 0 01-.14.21l-.65.36a.81.81 0 00-.29.29l-.36.65a.28.28 0 01-.24.15.28.28 0 01-.25-.15l-.36-.65a.71.71 0 00-.28-.29l-.66-.36a.27.27 0 01-.14-.24.29.29 0 01.14-.25l.66-.35a.71.71 0 00.28-.29c.07-.12.36-.57.36-.65a.28.28 0 01.25-.15zM47.88 7.6a.63.63 0 110 1.26.63.63 0 010-1.26zM22.36.887a.2.2 0 01.18.113l.24.44a.58.58 0 00.22.22l.52.27h-.03a.21.21 0 010 .36l-.49.27a.58.58 0 00-.19.27l-.27.49a.21.21 0 01-.36 0l-.27-.49a.58.58 0 00-.22-.22l-.49-.27a.2.2 0 010-.36l.49-.27a.58.58 0 00.22-.22l.27-.49a.2.2 0 01.18-.113zM29.95 0a.42.42 0 110 .84.42.42 0 010-.84z"
      />
      <path
        fill={secondaryColor}
        fillRule="nonzero"
        d="M8.82 49.777a.2.2 0 01.18.113l.29.49a.5.5 0 00.22.21l.49.27h-.02a.21.21 0 010 .37l-.49.27a.56.56 0 00-.22.21c-.05.09-.27.43-.27.49a.2.2 0 01-.36 0c-.04-.06-.22-.4-.27-.49a.56.56 0 00-.22-.21l-.49-.27a.21.21 0 010-.37l.49-.27a.5.5 0 00.22-.21l.27-.49a.2.2 0 01.18-.113zM38.81 36.28a.29.29 0 01.25.15c.05.08.29.53.35.65.07.12.17.22.29.29l.66.35a.29.29 0 01.14.28.27.27 0 01-.14.21l-.66.36a.81.81 0 00-.29.29l-.35.65a.29.29 0 01-.25.15.28.28 0 01-.24-.15l-.36-.65a.81.81 0 00-.29-.29l-.65-.36a.28.28 0 01-.15-.24.29.29 0 01.15-.25l.65-.35a.81.81 0 00.29-.29c.07-.12.36-.57.36-.65a.28.28 0 01.24-.15zm14.77-11.81a.42.42 0 110 .84.42.42 0 010-.84zM44.3 14.35a.42.42 0 110 .84.42.42 0 010-.84zM13.887 2.69a2.11 2.11 0 11-1.614 3.9 2.11 2.11 0 011.614-3.9zm-.807.68a1.27 1.27 0 10-.02 2.54 1.27 1.27 0 00.02-2.54z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M34.6 11.73L25.5 14a3.39 3.39 0 00-2.11 1.59L11 37a2.54 2.54 0 001 3.44L25.11 48a2.54 2.54 0 003.46-.93L40.93 25.7a3.41 3.41 0 00.32-2.63l-2.6-9a3.35 3.35 0 00-1.55-2 3.4 3.4 0 00-2.5-.34zm.47 8.93a2.53 2.53 0 11-4.376-2.541 2.53 2.53 0 014.376 2.541z"
      />
      <path
        fill="#CCDCFF"
        fillRule="nonzero"
        d="M28.8 14.23l9.32 1c.327.04.644.128.94.259l2.19 7.581a3.41 3.41 0 01-.32 2.63l-3.12 5.4-16.34 14.8-2.735-1.576a2.52 2.52 0 00.595-.374l1.29-1.09a2.52 2.52 0 01-3.56-.31l-5.501-6.516 9.79-16.917L26.27 15a3.38 3.38 0 012.53-.77zM10.75 37.66l3.35 3.99-2.1-1.21a2.541 2.541 0 01-1.25-2.78zm23.4-20.42a2.53 2.53 0 10.92 3.46v-.04a2.53 2.53 0 00-.92-3.42zm.45-5.52a3.4 3.4 0 012.5.35c.438.253.809.6 1.089 1.01a3.347 3.347 0 00-1.049-.3l-4.741-.51z"
      />
      <path
        stroke="#049"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M34.05 37.6l6.88-11.9a3.41 3.41 0 00.32-2.63l-2.6-9a3.35 3.35 0 00-1.55-2 3.4 3.4 0 00-2.5-.35L25.5 14a3.39 3.39 0 00-2.11 1.59L11 37a2.54 2.54 0 001 3.44L25.11 48a2.54 2.54 0 003.46-.93l3.8-6.57"
      />
      <path
        fill={primaryColor}
        fillRule="nonzero"
        d="M37.14 12.78l-9.32-1a3.37 3.37 0 00-2.53.77L6.36 28.45A2.52 2.52 0 006 32l9.77 11.64a2.52 2.52 0 003.56.31l18.98-15.88a3.42 3.42 0 001.2-2.36l.64-9.34a3.4 3.4 0 00-3-3.59h-.01zm-2.61 8.55a2.53 2.53 0 11.31-3.57 2.54 2.54 0 01-.31 3.57z"
      />
      <path
        fill="#0F66B5"
        fillRule="nonzero"
        d="M37.27 12.85v-.04l.221.038a3.3 3.3 0 011.869 1.122 3.37 3.37 0 01.797 2.182l-.007.218-.64 9.34a3.42 3.42 0 01-1.043 2.219l-.157.141-18.94 15.86a2.52 2.52 0 01-3.426-.161l-.134-.149L14.45 42a2.53 2.53 0 003.407.45l.143-.11L36.31 27a3.37 3.37 0 001.17-2.15l.02-.21.641-9.371a3.368 3.368 0 00-.648-2.21l-.133-.169-.035-.031-.055-.009z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M37.14 12.78l-9.32-1a3.37 3.37 0 00-2.53.77L6.36 28.45A2.52 2.52 0 006 32l9.77 11.64a2.52 2.52 0 003.56.31l1.29-1.09a2.52 2.52 0 01-3.56-.31l-9-10.66a1.27 1.27 0 01.16-1.79L26.27 15a3.38 3.38 0 012.53-.77l9.32 1a3.33 3.33 0 012 1 3.3 3.3 0 00-.76-2.23 3.35 3.35 0 00-2.22-1.22z"
      />
      <path
        fill="#FEBA6F"
        fillRule="nonzero"
        d="M17.3 42.76a2.54 2.54 0 01-2.85-.76l1.36 1.62a2.52 2.52 0 003.56.31l1.29-1.09a2.51 2.51 0 01-3.36-.08z"
      />
      <path
        stroke="#049"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8.94 26.28l-2.58 2.17A2.52 2.52 0 006 32l9.77 11.64a2.52 2.52 0 003.56.31l18.98-15.88a3.42 3.42 0 001.2-2.36l.64-9.34a3.4 3.4 0 00-3-3.59l-9.32-1a3.37 3.37 0 00-2.53.77l-11.84 9.93M11.53 24.11l-.65.54"
      />
      <circle
        cx={32.9}
        cy={19.39}
        r={2.53}
        stroke="#049"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
      <path
        stroke="#049"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M34.4 17.35a6.59 6.59 0 001.42 2.89 6.75 6.75 0 10.83-9.51 7 7 0 00-1.53 1.84M18.26 36.08l9.7-8.14M13.93 30.91l6.46-5.43M16.1 33.49l9.69-8.13"
      />
      <path
        fill={secondaryColor}
        fillRule="nonzero"
        d="M26.459 11.93l.147.197a6.76 6.76 0 01-2.323 9.87c-1.751.938-4.179.736-7.283-.607a6.69 6.69 0 01-1.39-4.09 6.76 6.76 0 0110.849-5.37z"
      />
      <path
        fill={primaryColor}
        fillRule="nonzero"
        d="M25.19 10.67a6.75 6.75 0 01-9.46 9.46 6.75 6.75 0 109.46-9.46z"
      />
      <path
        stroke="#049"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M15.51 12.24a6.75 6.75 0 105.58-3 6.79 6.79 0 00-3.77 1.15"
      />
      <path
        stroke="#049"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M18.56 16.24l1.92 1.69 3.14-3.16"
      />
      <path d="M0 0h54v54H0z" />
    </g>
  </svg>
);
const SvgPriceTag = withVariationColors(
  ({ primaryColor, secondaryColor, fillColor, title, titleId, ...props }) => (
    <Container {...props}>
      <SvgComponent
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        fillColor={fillColor}
        title={title}
        titleId={titleId}
      />
    </Container>
  )
);
const MemoSvgPriceTag = React.memo(SvgPriceTag);
export default MemoSvgPriceTag;
